import tenantsManifest from "./tenants.json";
const activeTenantId = (process.env.VUE_APP_TENANT || tenantsManifest.defaultTenantId).toLowerCase();
const activeDefinition = tenantsManifest.tenants[activeTenantId];

if (!activeDefinition) {
	throw new Error(`Unknown VUE_APP_TENANT "${activeTenantId}"`);
}

const tenantAssetContext = require.context("@tenant-assets", true, /\.(svg|png|jpe?g|webp)$/i);
const tenantPrefix = `tenants/${activeTenantId}/`;

function resolveTenantAsset(assetPath: string): string {
	const normalizedPath = assetPath.replace(/^\/+/, "");
	if (!normalizedPath.startsWith(tenantPrefix)) {
		throw new Error(`Tenant asset path must start with "${tenantPrefix}", got "${assetPath}"`);
	}
	return tenantAssetContext(`./${normalizedPath.slice(tenantPrefix.length)}`);
}

export const tenant = {
	id: activeTenantId,
	...activeDefinition,
	assets: {
		...activeDefinition.assets,
		headerLogoUrl: resolveTenantAsset(activeDefinition.assets.headerLogoPath),
		signInLogoUrl: resolveTenantAsset(activeDefinition.assets.signInLogoPath),
		projectPlaceholderImageUrl: resolveTenantAsset(activeDefinition.assets.projectPlaceholderImagePath),
		faviconUrl: "/favicon.ico",
		embeddedViewerWatermarkImageUrl: activeDefinition.assets.embeddedViewerWatermarkImagePath
			? resolveTenantAsset(activeDefinition.assets.embeddedViewerWatermarkImagePath)
			: ""
	}
};
